import React, { Component } from 'react';
import '../App.css';
import { HashLink as Link } from 'react-router-hash-link';

class Home extends Component {

  render() {
    
    return (
      <div className="App">
        <div className="home-cards-contain">
          <Link to="/slides/#for-employers-section" id="employer-experience-card" className="home-cards-item"></Link>
          <Link to="/slides/#cardholder-experience-section" id="cardholder-experience-card" className="home-cards-item"></Link>
          <Link to="/slides/#paperless-trees-section" id="paperless-trees-card" className="home-cards-item"></Link>
        </div>
      </div>
    );
  }
}

export default Home;
